import {type FC} from "react"
import {Button, Typography} from "@mui/material"
import {useTranslation} from "react-i18next"

type Props = {
  refetch: () => void
}

const RefreshButton: FC<Props> = (props) => {
  const {t} = useTranslation()
  return (
    <Button
      id="atomRefreshButton"
      sx={{
        color: "#053747",
        padding: "4px 18px 4px 18px",
        border: "1px solid #053747",
        boxShadow: "none",
        backgroundColor: "#fff",
        ":hover": {
          backgroundColor: "rgb(230,235, 237)",
          borderColor: "rgb(5, 55, 71)",
          color: "rgb(5, 55, 71)",
        },
        ":active": {
          backgroundColor: "rgb(205, 215, 218)",
          borderColor: "rgb(5, 55, 71)",
          color: "rgb(5, 55, 71)",
        },
      }}
      variant="outlined"
      onClick={() => props.refetch()}
    >
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: "600",
          color: "#053747",
          textTransform: "capitalize",
        }}
      >
        {t("Refresh")}
      </Typography>
    </Button>
  )
}

export default RefreshButton
